import { useRoute } from "@react-navigation/core";
import { NavigationProp, RouteProp } from "@react-navigation/native";
import React from "react";
import { View, useWindowDimensions } from "react-native";
import { FoodiOfferDetail } from "../../../../web-components/offerDetail";
import { HomeScreens } from "../../navigation/HomeScreens";

interface IProps {
  navigation: NavigationProp<any>;
}

export const OfferDetailScreen: React.FC<IProps> = ({ navigation }) => {
  const route: RouteProp<
    { params: { offerId: string; holdingId?: string } },
    "params"
  > = useRoute();
  const offerId = route.params?.offerId ?? "";
  const holdingId = route.params?.holdingId;
  const { height } = useWindowDimensions();

  // Scroll via a plain overflow container bounded to the window height — NOT a
  // react-native-web ScrollView. RNW ScrollView bakes `transform: translateZ(0)`
  // into its scroll node, which becomes the containing block for `position:
  // fixed` descendants and traps the embedded MFE's mobile filter bottom-sheet
  // (it scrolls with the page instead of staying pinned to the viewport). A
  // transform-free View lets the sheet's `fixed` resolve against the viewport.
  return (
    <View
      // @ts-ignore — web-only overflow value; RNW renders it as a scroll box.
      style={{ height, overflow: "scroll", backgroundColor: "#fff" }}
    >
      <FoodiOfferDetail
        offerId={offerId}
        holdingId={holdingId}
        goBack={() => navigation.goBack()}
        checkout={() =>
          navigation.navigate(HomeScreens.ORDER_CHECKOUT_SCREEN, {
            offerId,
            holdingId,
          })
        }
      />
    </View>
  );
};
